<span class="icon-{{icon}}"
  [attr.aria-hidden]="ariaHidden"
  [class.support-rtl]="supportRtl">
</span>
